export enum ReportType {
  EVENT_LIST,
  RESERVATION_SUMMARY,
  PAYMENT_SUMMARY,
  RSVP_SUMMARY,
  RESERVATION_COMPARE,
  RSVP_COMPARE
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/report-type.enum.ts